// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"d02e486f","70":"32fef241","249":"c7bcb34a","284":"8f963dbc","388":"e717c532","453":"6efdb569","521":"8f1e76ea","704":"b67ae1d3","705":"84ef0eaa","761":"4ddfbe99","912":"8c4d4684","921":"a81de450","961":"4429c0ae","975":"11c6c037"}[chunkId] + ".chunk.js";
};